var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('BaseFrontOfficeParagraph',{staticClass:"d-block mb-4",domProps:{"textContent":_vm._s(_vm.$t('auth.reset.done.message'))}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }